module.exports = __webpack_public_path__ + "img/logo_google_play.4f0f5b96.png";